let Test = require('@/mixins/Forms/2022/NRCA_LTI_02_A')

module.exports = {

    mixins: [Test],

    data() {
        return {
            skipAnswersIds: ['2.2', '2.3'],
            form: new Form({
                construction_inspection: {
                    name: `Construction Inspection`,
                    code_reference: `NA7.6.2.4`,
                    questions: {
                        question_1: {
                            id: `1`,
                            type: 'Boolean',
                            question: `The automatic time switch controls are shown on plan documents and are installed.`,
                            code_reference: `NA7.6.2.5(a)`,
                            answer: false
                        },
                        question_2: {
                            id: `2`,
                            type: 'Boolean',
                            question: `Automatic time switch controls are programmed with acceptable weekday, weekend, and holiday (if applicable) schedules.`,
                            code_reference: `NA7.6.2.5(b), Section 110.9(b)1Aii, Section 130.1(c)1A, Section 130.1(c)4, Section 160.5(b)4Cia, Section 160.5(b)4Civ`,
                            answer: false
                        },
                        question_3: {
                            id: `3`,
                            type: 'Boolean',
                            question: `Document weekday, weekend, and holidays schedules, as well as all set-up and preference program settings.`,
                            code_reference: `NA7.6.2.5(c)`,
                            answer: false
                        },
                        question_4: {
                            id: `4`,
                            type: 'Boolean',
                            question: `The correct time and date are properly set in the automatic time switch controls.`,
                            code_reference: `NA7.6.2.4(d)`,
                            answer: false
                        },
                        question_5: {
                            id: `5`,
                            type: 'Boolean',
                            question: `The battery backup (if applicable) is installed and energized.`,
                            code_reference: `NA7.6.2.5(e), Section 110.9(b)1`,
                            answer: false
                        },
                        question_6: {
                            id: `6`,
                            type: 'Boolean',
                            question: `Manual override time limit is set to no more than 2 hours, OR The automatic time switch control's manual override time is exempt from the 2-hour limit.`,
                            code_reference: `NA7.6.2.5(f), Section 110.9(b)1Ai, Section 130.1(c)3B, Section 160.5(b)4A`,
                            answer: false
                        },
                        question_7: {
                            id: `7`,
                            type: 'Boolean',
                            question: `Manual override switches located remotely from area with controlled luminaires allow the user to see the controlled luminaires or have a visual signal or display showing the current state of the controlled luminaires.`,
                            code_reference: `NA7.6.2.5(g), Section 130.1(c)3A, Section 130.1(a), Section 160.5(b)4Ciiia, Section 160.5(b)4A`,
                            answer: false
                        },
                    },
                    result: false,
                },
                functional_test: {
                    name: ` Functional Testing`,
                    code_reference: `NA7.6.2.5`,
                    steps: {
                        step_1: {
                            id: `1`,
                            name: `Simulate occupied condition in the controlled space.`,
                            code_reference: `NA7.6.2.6(a)`,
                            questions: {
                                question_1: {
                                    id: `1.1`,
                                    type: 'Boolean',
                                    question: `The automatic time switch control turns on the controlled lighting.  <cec-database-of-devices></cec-database-of-devices>`,
                                    code_reference:`NA7.6.2.6(a)1`,
                                    answer: false
                                },
                            }
                        },
                        step_2: {
                            id: `2`,
                            name: `Simulate an unoccupied condition in the controlled space.`,
                            code_reference: `NA7.6.2.6(b)`,
                            questions: {
                                question_1: {
                                    id: `2.1`,
                                    type: 'Boolean',
                                    question: `The automatic time switch control turns off all controlled lighting.`,
                                    code_reference: `NA7.6.2.6(b)2, Section 130.1(c)1A, Section 160.5(b)4Cia`,
                                    answer: false
                                },
                                question_2: {
                                    id: `2.2`,
                                    type: 'Boolean',
                                    question: `For the area controlled by an automatic time switch control with a configured automatic holiday shut-off, the controlled lighting can be turned off automatically by the holiday shut-off, <b>OR</b> the automatic time switch control is exempt from incorporating an automatic holiday shut-off.`,
                                    code_reference: `NA7.6.2.6(b)2, Section 110.9(b)1Aii, Section 130.1(c)4, Section 160.5(b)4Civ`,
                                    answer: false
                                },
                                question_3:{
                                    id:`2.3`,
                                    type: 'Boolean',
                                    question:`For the area controlled by an automatic time switch control with a time override located in and for the area, the lighting can be turned on manually by initiating the time override. The lighting is configured to remain on for no more than 2 hours OR the area is exempt from the 2-hour time override limit.`,
                                    code_reference: `NA7.6.2.6(b)3, Section 110.9(b)1Ai, Section 130.1(c)3B, Section 160.5(b)4Ciiib`,
                                    answer:false
                                }
                            }
                        }
                    },
                    result: false,
                },
                comments: '',
                testResult: false,
            })
        }
    },

}


